import { atom } from "jotai";

export const poDataAtom = atom(null);
export const poListAtom = atom([]);
export const poDetailAtom = atom(null);
